var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "md:pl-10 w-full md:pr-10" },
    [
      _vm.isReviewable
        ? [
            _c("h1", { staticClass: "mt-2 mb-4 font-sans-bold" }, [
              _vm._v("Submit resource details"),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-6" }, [
              _vm._v(
                "\n            When you have completed entering your resource information, please submit for review by the Reimagine team. Once the event is published and is live on the Reimagine Resources website, you will receive an email notification.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("p", { ref: "agree", staticClass: "mb-6" }, [
              _vm._v(
                "\n            By submitting my resource information, I acknowledge and agree: (A) that I have read and agree to the Reimagine Resources "
              ),
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href: "https://letsreimagine.org/terms-conditions",
                  },
                },
                [_vm._v("Terms & Conditions")]
              ),
              _vm._v(
                " and (B) if I am submitting on behalf of an organization, I warrant that I am authorized by the organization to do so on its behalf.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-6" }, [
              _c("div", { staticClass: "mb-12" }, [
                _c("div", { staticClass: "select-box flex-wrap" }, [
                  _c("label", { staticClass: "text-base font-normal w-full" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.agreeToTerms,
                          expression: "agreeToTerms",
                        },
                      ],
                      attrs: { type: "checkbox", name: "agree" },
                      domProps: {
                        checked: Array.isArray(_vm.agreeToTerms)
                          ? _vm._i(_vm.agreeToTerms, null) > -1
                          : _vm.agreeToTerms,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.agreeToTerms,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.agreeToTerms = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.agreeToTerms = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.agreeToTerms = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "check inline-block mr-2" }),
                    _vm._v(
                      " I agree to terms for resource submission.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("agree"),
                          expression: "errors.has('agree')",
                        },
                      ],
                      staticClass: "error text-error-red text-lg w-full",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("agree")))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button mb-5",
                  class: { "opacity-50 cursor-not-allowed": _vm.disableButton },
                  attrs: { disabled: _vm.disableButton },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.isSubmittable.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm.saving
                    ? [_vm._v("Processing...")]
                    : [_vm._v("Submit for Review")],
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-6" }, [
              _vm._v(
                "PLEASE NOTE: If you receive an error message upon clicking the submit button above, you have not sufficiently provided some information. Please review your resource and complete all the required fields."
              ),
            ]),
          ]
        : [
            _c("h1", { staticClass: "mb-6" }, [_vm._v("Resource Status")]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "mb-6" },
              [
                _vm.resource.published
                  ? [
                      _vm._v(
                        "\n                Your resource has been published!\n            "
                      ),
                    ]
                  : _vm.resource.status == "unpublished"
                  ? [
                      _vm._v(
                        "\n                This resource has been unpublished by Reimagine staff.\n            "
                      ),
                    ]
                  : [
                      _vm._v(
                        "\n                Your resource has been submitted for review!\n            "
                      ),
                    ],
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }